import { NoticeProxy } from "@service/components/notice-hub/helpers/NoticeProxy";
import { Notice } from "@service/components/toast/type/Notice";
import {MutationTree} from "vuex";
import { GroupedNoticeParams, NoticeState } from "../types/NoticeState";

export const mutations: MutationTree<NoticeState> = {
    setQueue(state, payload: Notice[]) {
        state.queue = payload;
    },
    updateGroup(state, payload: GroupedNoticeParams) {
        state.groups[payload.groupId] = [...state.groups[payload.groupId], ...payload.data]
    },
    initGroup(state, payload: GroupedNoticeParams) {
        state.groups[payload.groupId] = payload.data;
    },
    removeGroup(state, payload: string) {
        delete state.groups[payload]
    },
    setProxy(state, payload: NoticeProxy) {
        state.proxy = payload;
    }
}
